export default [
  {
    id: '590ef771-71fd-418c-81a5-2f8be3f08d32',
    path: 'data-quality-manage',
    name: 'data-quality-manage',
    meta: { title: '数据质量管理' },
    children: [
      {
        id: '950dffea-3aa9-4c6a-813a-3546b7e21b8d',
        path: 'data-quality-assessment',
        name: 'data-quality-assessment',
        component: () => {
          return import('../views/dataQualityManage/dataQualityAssessment')
        },
        meta: {
          title: '数据质量评估',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '34ff299d-c226-4c02-989c-16e1d1fffa19',
        path: 'data-rule-setting',
        name: 'data-rule-setting',
        component: () => {
          return import('../views/dataQualityManage/dataRuleSetting')
        },
        meta: {
          title: '数据规则设置',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            addTo: {
              id: 3,
              name: 'addTo',
              desc: '添加到',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            export: {
              id: 5,
              name: 'export',
              desc: '导出',
              access: true,
            },
          },
        },
      },
      {
        id: '75e4f871-d495-415e-877c-a855228b2b31',
        path: 'data-rule-list',
        name: 'data-rule-list',
        component: () => {
          return import('../views/dataQualityManage/dataRuleList')
        },
        meta: {
          title: '数据规则清单',
          keepAlive: false,
        },
      },
      {
        id: 'd21f500f-4f2e-4568-8f06-d6f1cc9a64f0',
        path: 'approval-data',
        name: 'approval-data',
        component: () => {
          return import('../views/dataQualityManage/ApprovalData')
        },
        meta: {
          title: '实体数据审批',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            approval: {
              id: 1,
              name: 'approval',
              desc: '审批',
              access: true,
            },
            submit: {
              id: 2,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            update: {
              id: 3,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 4,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '867e8251-a238-cb3a-b281-31fb96c64084',
        path: 'approval',
        name: 'approval',
        component: () => {
          return import('../views/dataQualityManage/components/approval.vue')
        },
        meta: {
          title: '审批详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-quality-manage/approval-data',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            approval: {
              id: 1,
              name: 'approval',
              desc: '审批',
              access: true,
            },
            submit: {
              id: 2,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            update: {
              id: 3,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 4,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '66752826-bbe4-efe1-27b1-d0ddd84803f5',
        path: 'read',
        name: 'read',
        component: () => {
          return import('../views/dataQualityManage/components/read.vue')
        },
        meta: {
          title: '审批详情查看',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-quality-manage/approval-data',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            approval: {
              id: 1,
              name: 'approval',
              desc: '审批',
              access: true,
            },
            submit: {
              id: 2,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            update: {
              id: 3,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 4,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '8711f5fa-1b49-4105-9ebc-c6194ac75133',
        path: 'data-source',
        name: 'data-source',
        component: () => {
          return import('../views/dataQualityManage/dataSource')
        },
        meta: {
          title: '质检源管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: 'a4f979fa-daff-44ed-bbb5-a4c5a9b1f207',
        path: 'quality-task-form',
        name: 'quality-task-form',
        component: () => {
          return import('../views/dataQualityManage/components/qualityTaskForm')
        },
        meta: {
          title: '数据质检管理详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-quality-manage/quality-task',
        },
      },
      {
        id: '41306afd-4158-4073-8c33-3a77151cedf9',
        path: 'task-report',
        name: 'task-report',
        component: () => {
          return import('../views/dataQualityManage/taskReport')
        },
        meta: { title: '质检报告', hidden: true },
      },
      {
        id: '1f121b37-f3fc-4cbd-bd53-5ab51b51716c',
        path: 'quality-task-detail',
        name: 'quality-task-detail',
        component: () => {
          return import('../views/dataQualityManage/components/qualityTaskDetail')
        },
        meta: {
          title: '数据质检管理',
          hidden: true,
        },
      },
      {
        id: 'f8434edc-f311-4400-9e85-66903ac54233',
        path: 'quality-task',
        name: 'quality-task',
        component: () => {
          return import('../views/dataQualityManage/qualityTask')
        },
        meta: {
          title: '数据质检管理',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: 'bc36d94d-08a5-454e-9831-1c013d401184',
        path: 'quality-report',
        name: 'quality-report',
        component: () => {
          return import('../views/dataQualityManage/qualityReport')
        },
        meta: {
          title: '数据质量报告',
          keepAlive: false,
        },
      },
      {
        id: '3cda33fa-1314-4e5d-b7f7-05e721808812',
        path: 'data-rectification',
        name: 'data-rectification',
        component: () => {
          return import('../views/dataQualityManage/dataRectification')
        },
        meta: {
          title: '质检校验清单',
          keepAlive: false,
          operations: {
            read: {
              id: 0,
              name: 'read',
              desc: '详情',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '整改',
              access: true,
            },
          },
        },
      },
      {
        id: 'd51135c0-72b9-41ab-a527-f8540f0242bf',
        path: 'data-approval',
        name: 'data-approval',
        component: () => {
          return import('../views/dataQualityManage/dataApproval')
        },
        meta: {
          title: '数据审批',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            approval: {
              id: 2,
              name: 'approval',
              desc: '审批',
              access: true,
            },
            preview: {
              id: 3,
              name: 'preview',
              desc: '预览',
              access: true,
            },
          },
        },
      },
      {
        id: 'd621c468-7598-41bf-ab98-4e13b4d48885',
        path: 'data-preview',
        name: 'data-preview',
        component: () => {
          return import('../views/dataQualityManage/dataPreview')
        },
        meta: {
          title: '数据审批详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-quality-manage/data-approval',
        },
      },
      {
        id: '98b1c749-f319-480a-8bf9-0d255640d919',
        path: 'error-detail',
        name: 'error-detail',
        component: () => {
          return import('../views/dataQualityManage/errorDetail')
        },
        meta: {
          title: '数据问题清单',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-quality-manage/data-rectification',
        },
      },
      {
        id: 'b6a9bbb8-c20e-486a-92f3-737ebd3be307',
        path: 'rectification-details',
        name: 'rectification-details',
        component: () => {
          return import('../views/dataQualityManage/rectificationDetails')
        },
        meta: {
          title: '数据整改详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-quality-manage/data-rectification',
        },
      },
    ],
  },
]
